<template>
  <div class="container-lg">
    <h1 class="page-header">Assembly</h1>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="handleSubmit()" name="form">
        <div class="form-group row">
          <label class="col-sm-3">Name</label>
          <div class="col-sm-7">
            <ValidationProvider
              name="Assembly name"
              rules="required"
              v-slot="{ errors }"
            >
              <input class="form-control" type="text" v-model="item.name" />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3">Notes</label>
          <div class="col-sm-9">
            <textarea class="form-control" type="text" v-model="item.notes" />
          </div>
        </div>

        <div class="nav nav-tabs">
          <div class="nav-item">
            <a
              class="nav-link"
              :class="{ active: tab === 0 }"
              @click.prevent="tab = 0"
              >Form fields</a
            >
          </div>
          <div class="nav-item">
            <a
              class="nav-link"
              :class="{ active: tab === 1 }"
              @click.prevent="tab = 1"
              >Build steps</a
            >
          </div>
          <div class="nav-item">
            <a
              class="nav-link"
              :class="{ active: tab === 2 }"
              @click.prevent="tab = 2"
              >Test result</a
            >
          </div>
          <div class="nav-item">
            <a
              class="nav-link"
              :class="{ active: tab === 3 }"
              @click.prevent="tab = 3"
              >Explaination</a
            >
          </div>
        </div>
        <div class="mt-5"></div>

        <div class="row" v-if="tab === 0">
          <div class="col-2">
            <div class="nav nav-pills flex-column">
              <div
                v-for="(f, index) in item.fields"
                :key="index"
                class="nav-item"
              >
                <a
                  class="nav-link"
                  :class="{ active: tabField === index }"
                  @click.prevent="tabField = index"
                  >{{ f.field }}</a
                >
              </div>
              <div class="nav-item">
                <a class="nav-link" @click="handleAddFormField()">
                  <i class="fa fa-plus"></i> Add form field
                </a>
              </div>
            </div>
          </div>
          <div class="col-10">
            <div v-if="item.fields && item.fields[tabField]">
              <AssemblyFormField v-model="item.fields[tabField]" />
              <div class="text-right mt-5">
                <button
                  type="button"
                  class="btn btn-sm btn-danger"
                  @click.prevent="handleDelArrayElement(item.fields, tabField)"
                >
                  <i class="fa fa-trash"></i> Delete field
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="tab === 1">
          <div class="col-2">
            <div class="nav nav-pills flex-column">
              <div
                v-for="(step, index) in item.steps"
                :key="index"
                class="nav-item"
              >
                <a
                  class="nav-link"
                  :class="{ active: tabStep === index }"
                  @click="tabStep = index"
                  >{{ step.name || "New step" }}</a
                >
              </div>
              <div class="nav-item">
                <a class="nav-link" @click="handleAddStep()"
                  ><i class="fa fa-plus"></i> New</a
                >
              </div>
            </div>
          </div>
          <div class="col-10">
            <div class="float-right">
              <button
                type="button"
                class="btn btn-sm btn-danger mr-3"
                @click.prevent="handleDelArrayElement(item.steps, tabStep)"
              >
                <i class="fa fa-trash"></i> Delete build step
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click.prevent="handleCopyStep(tabStep)"
                title="Duplicate buid step"
              >
                <i class="fa fa-copy"></i>
              </button>
            </div>

            <AssemblyStep
              v-if="item.steps && item.steps[tabStep]"
              v-model="item.steps[tabStep]"
            ></AssemblyStep>
          </div>
        </div>

        <div v-if="tab === 2">
          <AssemblyForm :fields="item.fields" v-model="testData"></AssemblyForm>

          <div class="alert alert-warning" v-if="test && test.StepErrors">
            {{ test.StepErrors }}
          </div>
          <BOM :bom="test.bom" v-if="test" />
          <div v-if="!test">
            Click test to run the assembly using the default form field values.
          </div>
        </div>

        <div v-if="tab === 3">
          <AssemblyExplaination :value="test.info.Explanation" v-if="test" />
        </div>

        <!-- Form actions  -->
        <div class="mt-5">
          <div style="flex: auto">
            <div class="form-group row">
              <div class="col-sm-12 text-right">
                <button
                  class="btn btn-light mr-4"
                  type="button"
                  @click="$router.back()"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-secondary mr-4"
                  type="button"
                  @click.prevent="handleTest()"
                  :disabled="invalid"
                >
                  Test
                </button>
                <button
                  class="btn btn-primary"
                  type="submit"
                  :disabled="invalid"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <!-- <pre>{{ item }}</pre> -->
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";
import AssemblyStep from "../components/AssemblyStep";
import AssemblyFormField from "../components/AssemblyFormField";
import AssemblyExplaination from "../components/AssemblyExplaination";
import BOM from "../components/BOM";
import AssemblyForm from "../components/AssemblyForm"

export default {
  components: {
    AssemblyFormField,
    AssemblyStep,
    BOM,
    AssemblyForm,
    AssemblyExplaination,
  },
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        id: null,
        name: "",
        fields: [
          {
            field: "",
            label: "",
            type: "int",
            default: null,
            options: [],
          },
        ],
        steps: [
          {
            name: null,
          },
        ],
      },
      tab: 0,
      tabStep: 0,
      tabField: 0,
      test: null,
      testData: {}
    };
  },
  created() {
    this.load();
  },
  computed: {
    query() {
      return { tab: this.tab, step: this.tabStep, field: this.tabField };
    },
  },
  watch: {
    id() {
      this.load();
    },
    query() {
      this.$router.push({ query: this.query });
    },
  },
  methods: {
    handleTest() {
      this.test = null;
      this.bom = null;
      authFetch("/api/assembly/test", {
        method: "post",
        body: JSON.stringify(this.item),
      }).then((resp) => {
        resp.json().then((j) => {
          this.test = j;
        });
      });
    },
    handleDelArrayElement(arr, index) {
      arr = arr.splice(index, 1);
    },
    handleAddFormField() {
      this.item.fields.push({ field: "NewField", required: true });
      this.tabField = this.item.fields.length - 1;
    },
    handleCopyStep(index) {
      const step = JSON.parse(JSON.stringify(this.item.steps[index]));
      this.item.steps.splice(index, 0, step);
    },
    handleAddStep() {
      this.item.steps = this.item.steps || [];
      this.item.steps.push({ name: "New step" });
      this.tabStep = this.item.steps.length - 1;
    },
    handleSubmit() {
      let item = {
        name: this.item.name,
        notes: this.item.notes,
        steps: JSON.stringify(this.item.steps),
        fields: JSON.stringify(this.item.fields),
      };
      const body = JSON.stringify(item);
      if (this.item.id) {
        // Update existing
        authFetch("/db/assembly/" + this.item.id, {
          method: "put",
          body: body,
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      } else {
        // Add new
        authFetch("/db/assembly", {
          method: "post",
          body: body,
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      }
    },
    load() {
      this.tabStep = 0;
      if (!this.id) {
        this.item = {
          id: null,
          name: "",
          notes: "",
          steps: [],
          fields: [],
        };
        return;
      } else {
        authFetch("/db/assembly/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            this.item = Object.assign({
              id: data.id,
              name: data.name,
              notes: data.notes,
              fields: JSON.parse(data.fields) || [],
              steps: JSON.parse(data.steps) || [],
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
label {
  margin-top: 6px;
  color: #666;
}
</style>